/* global store */

export const callVPAID = () => {
  let e = null;
  if (parent && parent.AVP_VPAID) {
    e = parent.AVP_VPAID;
  } else {
    const c = parent.document.getElementsByTagName('iframe');
    for (let a = 0; a < c.length; a += 1) {
      const d = c[a];
      try {
        if (d && d.contentWindow && d.contentWindow.AVP_VPAID) {
          e = d.contentWindow.AVP_VPAID;
        }
      } catch (b) {
        console.log();
      }
    }
  }
  return e;
};

export const vpaidPresent = () => {
  const { vpaid } = store.getState();
  return (vpaid && callVPAID() && (typeof callVPAID().pauseAd === 'function'));
};



// WEBPACK FOOTER //
// ./app/javascript/renderer/utils/vpaid.js